var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "firewood_prod__container",
      class: { "firewood_prod--resp_active": _vm.responsive_modal },
    },
    [
      _c(
        "span",
        {
          staticClass: "woo_btn",
          on: {
            click: function ($event) {
              return _vm.triggerResponsiveModal()
            },
          },
        },
        [_vm._v("Buy Now")]
      ),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      !_vm.selected.stock
        ? _c("p", { staticClass: "out_of_stock" }, [_vm._v("Out of stock")])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "firewood_prod" }, [
        _c("div", { staticClass: "firewood_prod__step" }, [
          _vm._m(1),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "firewood_prod__variations" },
            _vm._l(_vm.bag_sizes, function (bag_size, index) {
              return _c(
                "div",
                { key: bag_size + index, staticClass: "firewood_prod__var" },
                [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.selected.bag_size,
                        expression: "selected.bag_size",
                      },
                    ],
                    attrs: { type: "radio", id: "bag_size-" + index },
                    domProps: {
                      value: index,
                      checked: _vm._q(_vm.selected.bag_size, index),
                    },
                    on: {
                      change: [
                        function ($event) {
                          return _vm.$set(_vm.selected, "bag_size", index)
                        },
                        function ($event) {
                          return _vm.updateProductImage()
                        },
                      ],
                    },
                  }),
                  _vm._v(" "),
                  _c("label", { attrs: { for: "bag_size-" + index } }, [
                    _c("span", { staticClass: "firewood_prod__attribute" }, [
                      _vm._v(_vm._s(bag_size)),
                    ]),
                    _vm._v(" "),
                    _vm.getSalePrice(index) && !_vm.user.retail
                      ? _c("span", { staticClass: "firewood_prod__price" }, [
                          _vm._v(
                            "\n\t\t\t\t\t\t\t£" +
                              _vm._s(_vm.getSalePrice(index)) +
                              " "
                          ),
                          _c("del", [
                            _vm._v("£" + _vm._s(_vm.getPrice(index))),
                          ]),
                        ])
                      : _vm.user.retail && _vm.getWholesalePrice(index)
                      ? _c("span", { staticClass: "firewood_prod__price" }, [
                          _vm._v(
                            "\n\t\t\t\t\t\t\t£" +
                              _vm._s(_vm.getWholesalePrice(index)) +
                              " "
                          ),
                          _c("del", [
                            _vm._v("£" + _vm._s(_vm.getPrice(index))),
                          ]),
                        ])
                      : _c("span", { staticClass: "firewood_prod__price" }, [
                          _vm._v("£" + _vm._s(_vm.getPrice(index))),
                        ]),
                  ]),
                  _vm._v(" "),
                  index == "barrow-bag" ||
                  index == "classic-dumpy" ||
                  index == "bulk-load"
                    ? _c(
                        "div",
                        {
                          staticClass: "fp_tooltip",
                          class: {
                            "fp_tooltip--open": _vm.tooltips[index].active,
                          },
                        },
                        [
                          _c(
                            "span",
                            {
                              staticClass: "fp_tooltip__i",
                              on: {
                                click: function ($event) {
                                  return _vm.activateTooltip(index)
                                },
                              },
                            },
                            [_c("span", [_vm._v("i")])]
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "fp_tooltip__tip" }, [
                            _vm._m(2, true),
                            _vm._v(" "),
                            _c("div", { staticClass: "fp_tooltip__checkbox" }, [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value:
                                      _vm.tooltips[index].local_confirmation,
                                    expression:
                                      "tooltips[index].local_confirmation",
                                  },
                                ],
                                attrs: {
                                  type: "checkbox",
                                  id: `local_confirmation-${index}`,
                                },
                                domProps: {
                                  checked: Array.isArray(
                                    _vm.tooltips[index].local_confirmation
                                  )
                                    ? _vm._i(
                                        _vm.tooltips[index].local_confirmation,
                                        null
                                      ) > -1
                                    : _vm.tooltips[index].local_confirmation,
                                },
                                on: {
                                  change: [
                                    function ($event) {
                                      var $$a =
                                          _vm.tooltips[index]
                                            .local_confirmation,
                                        $$el = $event.target,
                                        $$c = $$el.checked ? true : false
                                      if (Array.isArray($$a)) {
                                        var $$v = null,
                                          $$i = _vm._i($$a, $$v)
                                        if ($$el.checked) {
                                          $$i < 0 &&
                                            _vm.$set(
                                              _vm.tooltips[index],
                                              "local_confirmation",
                                              $$a.concat([$$v])
                                            )
                                        } else {
                                          $$i > -1 &&
                                            _vm.$set(
                                              _vm.tooltips[index],
                                              "local_confirmation",
                                              $$a
                                                .slice(0, $$i)
                                                .concat($$a.slice($$i + 1))
                                            )
                                        }
                                      } else {
                                        _vm.$set(
                                          _vm.tooltips[index],
                                          "local_confirmation",
                                          $$c
                                        )
                                      }
                                    },
                                    function ($event) {
                                      return _vm.localConfirmationChanged(index)
                                    },
                                  ],
                                },
                              }),
                              _vm._v(" "),
                              _c(
                                "label",
                                {
                                  attrs: { for: `local_confirmation-${index}` },
                                },
                                [_vm._v("Tick to confirm")]
                              ),
                            ]),
                            _vm._v(" "),
                            _c("span", { staticClass: "fp_tooltip__arr" }),
                          ]),
                        ]
                      )
                    : _vm._e(),
                ]
              )
            }),
            0
          ),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "firewood_prod__step" },
          [
            _vm._m(3),
            _vm._v(" "),
            _c("quantity", {
              attrs: { min: 1 },
              model: {
                value: _vm.selected.qty,
                callback: function ($$v) {
                  _vm.$set(_vm.selected, "qty", $$v)
                },
                expression: "selected.qty",
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _vm.cross_sells.length > 0
          ? _c("div", { staticClass: "firewood_prod__step" }, [
              _vm._m(4),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "firewood_prod__items" },
                _vm._l(_vm.cross_sells, function (product) {
                  return _c(
                    "div",
                    { key: product.id, staticClass: "firewood_prod__item" },
                    [
                      _c("figure", { staticClass: "firewood_prod__img" }, [
                        _c("img", { attrs: { src: product.img, alt: "" } }),
                      ]),
                      _vm._v(" "),
                      _c("p", { staticClass: "firewood_prod__title" }, [
                        _vm._v(_vm._s(product.name)),
                      ]),
                      _vm._v(" "),
                      product.sale && !_vm.user.retail
                        ? _c(
                            "p",
                            {
                              staticClass:
                                "firewood_prod__price firewood_prod__price--small",
                            },
                            [
                              _vm._v(
                                "\n\t\t\t\t\t\t£" + _vm._s(product.sale) + " "
                              ),
                              _c("del", [_vm._v("£" + _vm._s(product.price))]),
                            ]
                          )
                        : _vm.user.retail && product.wholesale_price
                        ? _c(
                            "p",
                            {
                              staticClass:
                                "firewood_prod__price firewood_prod__price--small",
                            },
                            [
                              _vm._v(
                                "\n\t\t\t\t\t\t£" +
                                  _vm._s(product.wholesale_price) +
                                  " "
                              ),
                              _c("del", [_vm._v("£" + _vm._s(product.price))]),
                            ]
                          )
                        : _c(
                            "p",
                            {
                              staticClass:
                                "firewood_prod__price firewood_prod__price--small",
                            },
                            [_vm._v("£" + _vm._s(product.price))]
                          ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "firewood_prod__control",
                          class:
                            product.qty > 0
                              ? "firewood_prod__control--added"
                              : "",
                        },
                        [
                          _c(
                            "span",
                            {
                              staticClass: "firewood_prod__add",
                              on: {
                                click: function ($event) {
                                  return _vm.addCrossSell(product)
                                },
                              },
                            },
                            [_vm._v("Add")]
                          ),
                          _vm._v(" "),
                          _c("quantity", {
                            model: {
                              value: product.qty,
                              callback: function ($$v) {
                                _vm.$set(product, "qty", $$v)
                              },
                              expression: "product.qty",
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  )
                }),
                0
              ),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.selected.bag_size && _vm.selected.log_size
          ? _c("div", { staticClass: "firewood_prod__add_to_basket" }, [
              _c(
                "div",
                {
                  staticClass: "firewood_prod__btn_wrap",
                  class: { "firewood_prod__btn_wrap--loading": _vm.loading },
                },
                [
                  _c(
                    "button",
                    {
                      staticClass: "firewood_prod__btn",
                      attrs: { type: "button", disabled: _vm.barrowBagTickBox },
                      on: {
                        click: function ($event) {
                          return _vm.addToBasket()
                        },
                      },
                    },
                    [_vm._v("Add to basket")]
                  ),
                  _vm._v(" "),
                  _c(
                    "svg",
                    {
                      attrs: {
                        xmlns: "http://www.w3.org/2000/svg",
                        "xmlns:xlink": "http://www.w3.org/1999/xlink",
                        width: "35",
                        height: "35",
                        viewBox: "0 0 100 100",
                        preserveAspectRatio: "xMidYMid",
                      },
                    },
                    [
                      _c("g", { attrs: { transform: "translate(50,50)" } }, [
                        _c("g", { attrs: { transform: "scale(0.7)" } }, [
                          _c("circle", {
                            attrs: {
                              cx: "0",
                              cy: "0",
                              r: "50",
                              fill: "#e75000",
                            },
                          }),
                          _c(
                            "circle",
                            {
                              attrs: {
                                cx: "0",
                                cy: "-19",
                                r: "15",
                                fill: "#ffffff",
                              },
                            },
                            [
                              _c("animateTransform", {
                                attrs: {
                                  attributeName: "transform",
                                  type: "rotate",
                                  dur: "1s",
                                  repeatCount: "indefinite",
                                  keyTimes: "0;1",
                                  values: "0 0 0;360 0 0",
                                },
                              }),
                            ],
                            1
                          ),
                        ]),
                      ]),
                    ]
                  ),
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "firewood_prod__total" }, [
                _c("span", { staticClass: "firewood_prod__total--price" }, [
                  _vm._v("£" + _vm._s(_vm.getTotal)),
                ]),
              ]),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.barrowBagTickBox
          ? _c("div", { staticClass: "firewood_prod__barrow_bag_error" }, [
              _c("p", [
                _vm._v(
                  "You must accept the " +
                    _vm._s(_vm.niceBagSize) +
                    " tick box before you can add this product to basket."
                ),
              ]),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm._m(5),
        _vm._v(" "),
        _c("figure", {
          staticClass: "firewood_prod__close",
          on: {
            click: function ($event) {
              _vm.responsive_modal = false
            },
          },
        }),
      ]),
      _vm._v(" "),
      _c("figure", {
        staticClass: "firewood_prod__closestrip",
        on: {
          click: function ($event) {
            _vm.responsive_modal = false
          },
        },
      }),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      {
        staticClass:
          "free_delivery_prod free_delivery_prod--yellow free_delivery_prod--tablet",
      },
      [
        _c("p", { staticClass: "free_delivery_prod__heading" }, [
          _vm._v("FREE delivery Nationwide on all firewood orders"),
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "free_delivery_prod__subtitle" }, [
          _c("span", [
            _vm._v(
              "Classic Dumpy and Barrow Bags available for local delivery only"
            ),
          ]),
          _vm._v(" "),
          _c(
            "a",
            { staticClass: "free_delivery_prod__link", attrs: { href: "#" } },
            [_vm._v("Learn More")]
          ),
        ]),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", { staticClass: "firewood_prod__heading" }, [
      _c("span", { staticClass: "firewood_prod__heading--orange" }, [
        _vm._v("Step 1."),
      ]),
      _vm._v(" Select bag size"),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [
      _vm._v("Only available for local delivery."),
      _c("br"),
      _c("a", { staticClass: "fp_check_postcode", attrs: { href: "#" } }, [
        _vm._v("Check your postcode"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", { staticClass: "firewood_prod__heading" }, [
      _c("span", { staticClass: "firewood_prod__heading--orange" }, [
        _vm._v("Step 2."),
      ]),
      _vm._v(" Quantity"),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", { staticClass: "firewood_prod__heading" }, [
      _c("span", { staticClass: "firewood_prod__heading--orange" }, [
        _vm._v("Step 3."),
      ]),
      _vm._v(" We recommend"),
      _c("span", { staticClass: "firewood_prod__heading--resi_hide" }, [
        _vm._v(" the following"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      {
        staticClass:
          "free_delivery_prod free_delivery_prod--yellow free_delivery_prod--mobile",
      },
      [
        _c("p", { staticClass: "free_delivery_prod__heading" }, [
          _vm._v("FREE delivery nationwide"),
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "free_delivery_prod__subtitle" }, [
          _c("span", [
            _vm._v("within 25 miles or Nationwide for orders over £150"),
          ]),
          _vm._v(" "),
          _c(
            "a",
            { staticClass: "free_delivery_prod__link", attrs: { href: "#" } },
            [_vm._v("Learn More")]
          ),
        ]),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }